import React, { useEffect, useState } from 'react'
import styles from './tippingSettingPreview.module.scss'
import ReactSelectField from '../../theme/ReactSelectField';
import { NumericFormat } from 'react-number-format';
import ThemeButton from '../../theme/ThemeButton';
import ModalLayout from '../../layouts/ModalLayout';
import { Col } from 'react-bootstrap';
import PaymentHeader from '../../paymentHeader/PaymentHeader';
import noImage from '../../../assests/Logo.svg'

const STAR_PATH =
    "M16.000 1.000 L19.233 11.550 L30.266 11.365 L21.231 17.700 L24.817 28.135 L16.000 21.500 L7.183 28.135 L10.769 17.700 L1.734 11.365 L12.767 11.550 Z";

const FILLED_STAR_COLOR = "#2549E8";
const EMPTY_STAR_COLOR = "#c4c4c4";
const TOTAL_STARS = 5;
const HIGH_RATING_THRESHOLD = 3;

const StarIcon = ({ filled }: { filled: boolean }) => (
    <svg
        viewBox="0 0 32 32"
        width="32"
        height="32"
        aria-hidden="true"
        shapeRendering="geometricPrecision"
        className={styles.star}
    >
        <path
            d={STAR_PATH}
            fill={filled ? FILLED_STAR_COLOR : EMPTY_STAR_COLOR}
            style={{ fill: filled ? FILLED_STAR_COLOR : EMPTY_STAR_COLOR }}
        />
    </svg>
);

interface IProps {
    handleToggle: () => void;
    title: string;
    show: boolean;
    size?: any;
    loading?: boolean;
    actionTitle?: string;
    data?: any
}


const TippingSettingPreviewModal = ({ title, show, handleToggle, data }: IProps) => {
    const [hoveredStar, setHoveredStar] = useState<number | null>(null);
    const [selectedRating, setSelectedRating] = useState<number | null>(null);
    const [showTipScreen, setShowTipScreen] = useState(false);

    const show_notes = [
        { label: 'Yes', value: 1 },
        { label: 'No', value: 0 }
    ];

    const showRatingScreen = Number(data?.is_service_score) === 1 && !showTipScreen;
    const activeStar = hoveredStar ?? selectedRating ?? 0;
    const isHighRating =
        selectedRating !== null && selectedRating >= HIGH_RATING_THRESHOLD;
    const isLowRating =
        selectedRating !== null && selectedRating < HIGH_RATING_THRESHOLD;
    const displayName = data?.name || "";
    const themeColor = data?.theme_color || "#2549e8";

    useEffect(() => {
        if (!show) {
            setHoveredStar(null);
            setSelectedRating(null);
            setShowTipScreen(false);
        }
    }, [show]);

    const handleStarClick = (star: number) => {
        setSelectedRating(star);
    };

    const handleNotToday = () => {
        handleToggle();
    };

    const handleSendTip = () => {
        setShowTipScreen(true);
    };

    const handleSubmitFeedback = () => {
        handleToggle();
    };

    const ratingPreview = (
        <div className={styles.ratingContainer}>
            <div className={styles.logoWrapper}>
                <div
                    className={styles.circle}
                    style={{ backgroundColor: data?.theme_color }}
                >
                    <img
                        src={data?.organization_media_details?.url ? data?.organization_media_details?.url : noImage}
                        alt=""
                    />
                </div>
            </div>

            {displayName && <h5 className={styles.orgName}>{displayName}</h5>}

            <p className={styles.question}>
                How would you rate your service today?
            </p>

            <div
                className={styles.stars}
                onMouseLeave={() => setHoveredStar(null)}
            >
                {Array.from({ length: TOTAL_STARS }, (_, index) => {
                    const starValue = index + 1;
                    const isFilled = starValue <= activeStar;

                    return (
                        <button
                            key={starValue}
                            type="button"
                            data-star={starValue}
                            className={styles.starButton}
                            aria-label={`Rate ${starValue} out of ${TOTAL_STARS} stars`}
                            onMouseEnter={() => setHoveredStar(starValue)}
                            onFocus={() => setHoveredStar(starValue)}
                            onBlur={() => setHoveredStar(null)}
                            onClick={() => handleStarClick(starValue)}
                        >
                            <StarIcon filled={isFilled} />
                        </button>
                    );
                })}
            </div>

            {isHighRating && (
                <div className={styles.followUp}>
                    <p className={styles.tipMessage}>
                        Thanks for your feedback, would you like to send a tip to thank your
                        service workers?
                    </p>
                    <div className={styles.buttonRow}>
                        <button
                            type="button"
                            className={styles.secondaryButton}
                            onClick={handleNotToday}
                        >
                            Not Today
                        </button>
                        <ThemeButton
                            type="button"
                            className={styles.primaryButton}
                            style={{ width: '100%' }}
                            onClick={handleSendTip}
                        >
                            Send 
                        </ThemeButton>
                    </div>
                </div>
            )}

            {isLowRating && (
                <div className={styles.followUp}>
                    <p className={styles.feedbackMessage}>
                        We’re sorry that you had a poor experience.  Your feedback is very important to us, please tell us more about your visit. Please include your contact information if you would like to be contacted by the manager.
                    </p>
                    <textarea
                        className={styles.feedbackInput}
                        disabled
                        placeholder={`Share details of your experience at ${displayName}`}
                        rows={5}
                        style={{ cursor: 'not-allowed' }}
                    />
                    <ThemeButton
                        type="button"
                        style={{ width: '100%', marginTop: '10px' }}
                        onClick={handleSubmitFeedback}
                    >
                        Submit
                    </ThemeButton>
                </div>
            )}
        </div>
    );

    const tippingPreview = (
        <div className={styles.tipperBottom}>
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "20px",
                    paddingTop: '0px'
                }}
            >
                <div
                    className={styles.circle}
                    style={{
                        backgroundColor: data?.theme_color,
                    }}
                >
                    <img src={data?.organization_media_details?.url ? data?.organization_media_details?.url : noImage} alt="" />
                </div>
            </div>
            <h5 className="">
                {data?.name}

            </h5>
            {data?.tipping_view === 1 && <Col xxl={12} xl={12} className="mb-2">
                <div className={styles.addCateg}>
                    <ReactSelectField
                        name="tipping_view"
                        className={`form_select ${styles.check}`}
                        options={show_notes}
                        isDisabled
                        placeholder="Select Property"
                        label={
                            ' Which property would you like to tip? (Optional)'
                        }
                    />
                </div>
            </Col>}

            {(!!data?.suggested_amount_1 ||
                !!data?.suggested_amount_2 ||
                !!data?.suggested_amount_3) && (
                    <div className={styles.suggestedAmount}>
                        <h6>Tip amount ($)</h6>
                        <div className={styles.suggestCards}>
                            {!!data?.suggested_amount_1 && (
                                <p
                                    style={{ cursor: 'not-allowed' }}
                                >
                                    {
                                        data?.suggested_amount_1
                                    }
                                </p>
                            )}
                            {!!data?.suggested_amount_2 && (
                                <p style={{ cursor: 'not-allowed' }}
                                >
                                    {
                                        data?.suggested_amount_2
                                    }
                                </p>
                            )}
                            {!!data?.suggested_amount_3 && (
                                <p style={{ cursor: 'not-allowed' }}
                                >
                                    {
                                        data?.suggested_amount_3
                                    }
                                </p>
                            )}
                        </div>
                    </div>
                )}
            <div className={styles.tipperRightForm}>
                {" "}
                <label htmlFor="">
                    {!!data?.suggested_amount_1 ||
                        !!data?.suggested_amount_2 ||
                        !!data?.suggested_amount_3
                        ? "Custom amount ($)"
                        : "Tip amount ($)"}
                </label>
                <br />
                <div className={styles.search}>
                    <NumericFormat
                        allowNegative={false}
                        style={{
                            cursor:
                                "not-allowed"
                        }}
                        disabled
                        decimalScale={2}
                        fixedDecimalScale={true}
                        type="text"
                        placeholder="Enter Amount"
                    />
                </div>
                {
                    data?.show_notes === 1 &&
                    <div className="my-2">
                        <label htmlFor="note">
                            Note <span>(Optional)</span>
                        </label>
                        <input
                            type="text"
                            id="note"
                            disabled
                            placeholder="Enter note"
                            className={styles.email}
                            style={{ marginBottom: '2px', cursor: 'not-allowed' }}
                        />

                    </div>
                }
            </div>
            <div
                style={{
                    display: "flex",
                    width: "100%",
                    justifyContent: "center",
                    marginTop: "15px",
                    padding: "0px 18px",
                }}
            >
                <ThemeButton
                    type="submit"
                    disabled
                    style={{ width: '100%' }}

                >
                    Send Tip
                </ThemeButton>
            </div>
        </div>
    );

    return (
        <ModalLayout
            title={title}
            show={show}
            size={465}
            handleToggle={handleToggle}
            isTippingPreview={true}

        >
            <div className={styles.formContainer}>
                <form className={styles.tipperContainer}>
                    {showRatingScreen ? ratingPreview : tippingPreview}
                </form>
                <PaymentHeader />
            </div>
        </ModalLayout>
    )
}

export default TippingSettingPreviewModal
